export var MessengersMenuFlags = /*#__PURE__*/function (MessengersMenuFlags) {
  MessengersMenuFlags["IS_CHAT_CHAT_ENABLED"] = "IS_CHAT_CHAT_ENABLED";
  MessengersMenuFlags["IS_CHAT_TELEGRAM_ENABLED"] = "IS_CHAT_TELEGRAM_ENABLED";
  MessengersMenuFlags["IS_CHAT_VK_ENABLED"] = "IS_CHAT_VK_ENABLED";
  MessengersMenuFlags["IS_CHAT_WHATSAPP_ENABLED"] = "IS_CHAT_WHATSAPP_ENABLED";
  MessengersMenuFlags["IS_CHAT_OK_ENABLED"] = "IS_CHAT_OK_ENABLED";
  return MessengersMenuFlags;
}({});
export var OS = /*#__PURE__*/function (OS) {
  OS["ios"] = "ios";
  return OS;
}({});